// src/client.ts
import { feathers } from "@feathersjs/feathers";
import authenticationClient from "@feathersjs/authentication-client";

// src/services/location/location.shared.ts
var locationsPath = "/location/v1/:tenantId";
var locationsMethods = ["find", "get", "create", "patch", "remove"];
var locationClient = (client) => {
  const connection = client.get("connection");
  client.use(locationsPath, connection.service(locationsPath), {
    methods: locationsMethods
  });
};

// src/services/machineProfile/machineProfile.shared.ts
var machineProfilesPath = "/machine-profile/v1/:tenantId";
var machineProfilesMethods = ["getByCode"];
var machineProfileClient = (client) => {
  const connection = client.get("connection");
  client.use(machineProfilesPath, connection.service(machineProfilesPath), {
    methods: machineProfilesMethods
  });
};

// src/utils/shared.ts
var isInSelectedLocations = (locationId, locations, allLocations) => {
  for (const loc of locations) {
    if (loc.locationId == locationId) return true;
    if (!allLocations.find((l) => l.locationId == loc.parentLocationId)) {
      return false;
    }
    return isInSelectedLocations(locationId, [allLocations.find((l) => l.locationId == loc.parentLocationId)], allLocations);
  }
  return false;
};
function fullLocationListFromTopLevel(allLocations, topLevel, direction = "Descendent | Ascending") {
  topLevel = topLevel.filter((l) => l.isEnabled);
  const full = [];
  const getChildLocationsFromList = (_all, _full, _parentLocation) => {
    _all.filter((l) => l.parentLocationId === _parentLocation.locationId).forEach((l) => {
      if (!l.isEnabled) return;
      if (!_full.some((item) => item.locationId === l.locationId)) {
        _full.push(l);
      }
      getChildLocationsFromList(_all, _full, l);
    });
  };
  topLevel.forEach((l) => {
    if (!full.some((item) => item.locationId === l.locationId)) {
      full.push(l);
    }
    if (direction === "Descendent" || direction === "AncestorDescendent") {
      getChildLocationsFromList(allLocations, full, l);
    }
    if (direction === "Ancestor" || direction === "AncestorDescendent") {
      let currentLocation = allLocations.find((loc) => loc.locationId === l.parentLocationId);
      while (currentLocation) {
        if (!full.some((item) => item.locationId === currentLocation.locationId)) {
          full.push(currentLocation);
        }
        currentLocation = allLocations.find((loc) => loc.locationId === currentLocation.parentLocationId);
      }
    }
  });
  return full;
}

// src/client.ts
var createClient = (connection, authenticationOptions = {}) => {
  const client = feathers();
  client.configure(connection);
  client.configure(authenticationClient(authenticationOptions));
  client.set("connection", connection);
  client.configure(locationClient);
  client.configure(machineProfileClient);
  return client;
};
export {
  createClient,
  fullLocationListFromTopLevel,
  isInSelectedLocations
};
//# sourceMappingURL=client.js.map